/**
 * 索赔3.0
 * 仓库发起|调整
 *  两个入口
 *  出货订单-详情-单品发起索赔 (add 为true)
 *  索赔列表-仓库发起-详情 (add 为false)
 *
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2025/11/19      1.0     First version
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React from "react";
import {Spin, Alert,InputNumber,message,Empty,Select} from "antd";
import {symbolMoneyUtil,getQueryString,isEmptyObject,getFileSuffix,toFixed2} from '@utils/utils';
import { renderFileType } from "@components/UploadFile/UploadImage/file.util";
import FormFormat from '@/components/FormFormat/FormFormat';
import Lang from "@/components/Lang/Lang";
import ClaimSkuWrap from "@/components/claimSkuWrap/SkuWrap";
import HttpServerAction from '@/api/httpServer.action';
import "./index.less";
export default class ClaimForm extends React.Component{
    static defaultProps = {
        add: true, //默认为true
    };
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            poItemId:"",
            showSuccess:false,
            sku:{}, // 该po商品内容
            model:{},//索赔详情
            values:{
            },
        }
        this.__getServerLanguage = __getServerLanguage;
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /**
     * 点击确认时 获取表单数据
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#6268
     ***/
    async handleOK(){
        if(this.onRefFormFormat){
            let res = await this.onRefFormFormat.handleOK();
            const { values,sku } = this.state;
            if(!values.wornQuantity){
                res.message = Lang({id:'PoSunChanPinShuLiang',default:"破损产品数量"});
                res.success = false;
            }else if(!values.wornBoxQuantity){
                res.message = Lang({id:'PoSunChanPinXiangShu',default:"破损产品箱数"});
                res.success = false;
            }else if((values.wornQuantity/sku.skuCapacity/(sku.skuCount||1))>values.wornBoxQuantity){
                res.message = Lang({id:'PoSunChanPinShuLiangBuNen',default:"破损产品数量不能大于箱数"});
                res.success = false;
            }else {
                const postData = {...res.data,...values};
                postData.refundAmountTotal = sku.pcsPrice? toFixed2(sku.pcsPrice * values.wornQuantity):0;
                res.data =postData
                res.sku = sku;
            }
            return res;
        }else {
            return{
                success:false,
                message:Lang({id:"ShuRuPoSunDeShangPinBianM",default:"输入破损的商品编码"})
            }
        }
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    // 赋值
    setValue(filed,value){
        let {values,sku} = this.state;
        values[filed] = value;
        if(filed=="wornQuantity"){
            values["quantity"] = value;//索赔数据PCS等于破损数量PCS
            values["normalQuantity"] = sku.quantity - value;
        }
        // else if(filed=="normalQuantity"){
        //     values["wornQuantity"] = values.quantity - value;
        // }
        this.setState({
            values:values
        })
    }
    /*
    * 撤消操作
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7948
    * */
    handleCancel(){
        if(this.props.handleCancel){
            this.props.handleCancel();
        }
    }
    getOption(sku={},quantity=1,sUnit,values={}){
        const canApplyNum = sku.claimQuantity&&sku.claimQuantity>0 ? sku.quantity - sku.claimQuantity : sku.quantity; // mgPoInfoVO 内的总量quantity - 已索赔的数量claimQuantity
        let list =  [
            {
                name:'damageCode',  // 售后原因
                title:<span className={"black89 fw_700 font_16"}>{this.__getServerLanguage('ShouHouYuanYin')}</span>,
                // cnTitleId:'ShouHouYuanYin',
                cnPlaceholderId:'QingXuanZeShouHouYuanYin',//请选择售后原因！
                required: true,
                type:"BtnSelect",
                list:__getDictList("claim_demage_order_damage_code")
            },
            {
                name:'quantity',  // 售后产品数量
                cnPlaceholderId:'TianXiePoSunChanPinShuLiangQingLiuYiDanWei',//填写破损产品数量，请留意单位
                // required: true,
                type:'OnlyRender',
                onlyRender:<div className={"borderInfoCard font_14 mt_16"}>
                    {/*   */}
                    <div className={"fw_700 font_16"}>{Lang({id: 'PoSunChanPinShuLiangKeHuG',default: '破损产品数量（客户购买共 {0} 箱 ｜{1} PCS)',params:[sku.actLoadQuantity,sku.quantity]})}</div>
                    {/*历史已申请赔付了 {sku.claimQuantity} {sUnit}*/}
                    {sku.claimQuantity>0?<div className={"mt_2 color-err"}>
                        {Lang({id: "LiShiYiShenQingPeiFuLe",default: `历史已申请赔付了 ${sku.claimQuantity+" PCS"}`,params:[sku.claimQuantity+" PCS"]})}
                      </div>:null}
                    {/* 黄色数字输入区域 */}
                    <div className={"yellowNumberArea mt_16 black89 autoRowNo"}>
                        <div className={"flex-item-ver-center"}>
                            <span className={"mr_8"}>{Lang({id:'PoSunChanPinXiangShu',default:"破损产品箱数"})}</span>
                            <InputNumber value={values.wornBoxQuantity}
                                         size={"large"}
                                         width={220}
                                         min={1}
                                         max={sku.actLoadQuantity}
                                         onChange={(v)=>this.setValue("wornBoxQuantity",v)}
                                         precision={0} />
                            <span className={"ml_8"}>{Lang({id:'Xiang',default:"箱"})}</span>
                        </div>
                        <div className={"flex-item-ver-center mt_24 lineBottom"}>
                            <span className={"mr_8"}>{Lang({id:'PoSunChanPinShuLiang',default:"破损产品数量"})}</span>
                            <InputNumber value={values.wornQuantity}
                                         size={"large"}
                                         width={220}
                                         min={1}
                                         max={canApplyNum}
                                         onChange={(v)=>this.setValue("wornQuantity",v)}
                                         precision={0} />
                            <span className={"ml_8"}>PCS</span>
                        </div>
                        <div className={"flex-item-ver-cente mt_12"}>
                            {Lang({id: 'ZhengChangShangPinShuLian', default: '正常商品数量'})}
                            <span className={'ml_4 color-green2 fw_700 font_16'}>{sku.actLoadQuantity - (values.wornBoxQuantity||0)}</span>
                            <span className={'ml_4'}>{Lang({id:'Xiang',default:'箱'})}</span>
                            <span className={"ml_8 fw_700"}>|</span>
                            <span className={'ml_8 color-green2 fw_700 font_16'}>{sku.quantity - (values.wornQuantity||0)- (sku.claimQuantity||0)}</span>
                            <span className={'ml_4'}>PCS</span>
                        </div>
                    </div>
                </div>,
            },
            {
                name:'consultFileList', // 上传凭证
                cnTitleId:'ShangChuanPingZheng',
                cnPlaceholderId:'QingShangChuanPingZheng',// 请上传凭证
                type:'UploadFileIcon',
                accept:'.mp4,.flv,.jpeg,.jpg,.png,.bmp,.doc,.docx,.xls, .xlsx, .pdf',
                topTips:<div className={"font_12 black45 m-under mb_4"}>{this.__getServerLanguage("ZhiChiTuPianShiPinWenDang")}</div>,
                required: true, // 发起时才是必填 | 调整编辑时可不填
                maxCount:5,
                fileSizeLimit: 20*1024*1024,
            },

            {
                name:'remark',// 说明
                cnTitleId:'ShuoMing',
                required: false,
                type:'TextArea',
                minRows: 5,
                maxLength: 512,
            },
        ]
        return list
    }
    onSearch(v){
        this.loading(true);
        HttpServerAction.postHttpAction('/service/mg/sale/claimDemage/query-in-storage-po-info',{
            keyword: v,
        },).then((resp)=>this.handleGetRes(resp.data)).catch(err=>this.handleGetRes(err));
    }
    onSelect(value, option){
        // 当用户从下拉列表中选择一个选项时
        this.getPoInfo(option.poItemId);
        // 清空list，隐藏下拉
        this.setState({
            list: []
        });
    }
    handleGetRes(res={}) {
        const {success, valid,models=[]} = res;
        this.loading(false);
        if (success && valid) {
           if(models&&models.length>0){
               if(models.length==1){
                   const skuInfo = models[0];
                   this.getPoInfo(skuInfo.poItemId);
               }else{
                   this.setState({
                       list:models
                   })
               }
           }else this.setState({
               showEmpty:true
           })
        }else{
            // 请先新增合同
            message.open({
                type: 'warning',
                content: res.message||Lang({id: 'CaoZuoShiBai',default:'操作失败'})
            });
        }
    }
    getPoInfo(poItemId){
        HttpServerAction.postHttpAction('/service/mg/sale/claimDemage/query-po-info',{
            poItemId: poItemId,
        },).then((resp)=>this.handlePoItemRes(resp.data)).catch(err=>this.handlePoItemRes(err));
    }
    handlePoItemRes(res={}) {
        const {success, valid,model} = res;
        this.loading(false);
        if (success && valid) {
            this.setState({
                sku:model
            })
        }else{
            message.open({
                type: 'warning',
                content: res.message||Lang({id: 'CaoZuoShiBai',default:'操作失败'})
            });
        }
    }
    componentWillMount() {
        if(this.props.onRef)this.props.onRef(this);
    }
    componentDidMount(){
    }
    render(){
        const { loading,values={}, sku={}, showEmpty,list=[]} = this.state;
        // 单位
        const sUnit = sku.skuCount>1?"PCS":__getServerDictItem("unit_type." + sku.skuUnit);
        return (<Spin spinning={loading}>
            <div className={"damageRegistrationForm black89 font_14"}>
                {/* 表单提示信息 - 使用antd5.0 Alert组件 */}
                <Alert
                    message= {Lang({id: 'ZhenDuiPoSunDeQingKuangJi', default:"针对破损的情况进行登记处理，登记提交后，将有业务或客户与客户协商赔偿方式"})}
                    type="info"
                    showIcon
                    style={{
                        marginBottom: '24px',
                        backgroundColor: '#F7F7FA',
                        border: 'none'
                    }}
                />
                {/* 商品编码输入 */}
                <div className="formSection">
                    <div className="formItemBlock">
                        <div className="label">
                            <span className={"color-red2 mr_4"}>*</span>
                            <span className={"fw_700 font_16"}>{Lang({id: 'ShuRuPoSunDeShangPinBianM', default: '输入破损的商品编码'})}</span>
                        </div>
                        <div className="inputWrapper">
                            {/*<Search placeholder={Lang({id: 'QingShuRu', default: '请输入'})} allowClear onSearch={(v)=>this.onSearch(v)} />*/}
                            <Select //allowClear
                                    showSearch
                                    onChange={this.onSearch.bind(this)}
                                    onSelect={this.onSelect.bind(this)}
                                    style={{ width: '100%' }}
                                    placeholder={Lang({id: 'QingShuRu', default: '请输入'})}
                                    onSearch={this.onSearch.bind(this)}
                                    options={list.map((item, index) => ({
                                        value: item.skuNo || '',
                                        label: <div><span className={"mr_8 fw_700"}>{item.poCode}</span>{item.buyerCode}</div>,
                                        key: index,
                                        poItemId: item.poItemId
                                    }))}
                                />
                        </div>
                    </div>
                </div>
                {/* 商品信息展示区域 */}
                {sku.poItemId?<>
                    <div className="borderInfoCard">
                        <div className={"font_16"}>{Lang({id: 'DingDan', default: '订单'})}<span className={"ml_4"}>{sku.poCode}</span></div>
                        <ClaimSkuWrap item={sku} />
                    </div>
                    {/*/!* 表单 区域 *!/*/}
                    {/*<TypeForm add={add} sku={sku} saveData={(data)=>this.save(data)} canApplyNum={canApplyNum} fromInitialValues={fromInitialValues} />*/}
                    <div className={"addForm"}>
                        {/* 表单 start */}
                       <FormFormat onRef={this.onRefForm}
                                    options={this.getOption(sku,values.quantity,sUnit,values)}
                                    formItemLayout={null}
                                    formLayout = "vertical" />
                    </div>
                </>:<>
                        {showEmpty?<Empty description={Lang({id: "WeiZhaoDaoFuHeTiaoJianDeJiLu",
                            default: "未找到符合条件的记录"})} />:<Empty description={Lang({id: "ShuRuPoSunDeShangPinBianM",default: "输入破损的商品编码"})} />}
                </>}
            </div>
        </Spin>)
    }
}

